import { IoIosClose } from 'react-icons/io'
import { Text, useMainContext } from '..'

const StackingSupportModal = ({ detail, onClose }) => {
    const {
        main: { lang },
    } = useMainContext()
    if (!detail.show) return <></>
    return (
        <div
            className={
                'w-screen h-screen left-0 top-0 z-[1000003] fixed backdrop-blur flex items-center justify-center px-2'
            }
        >			<div className={'lg:w-[480px] w-full rounded-md dark:bg-dStakingModal bg-slate-100'}>
                <div
                    className={
                        'w-full rounded-t-md h-[64px] flex bg-slate-200 dark:bg-primaryBg items-center justify-center relative'
                    }
                >
                    <Text tid={'staking-add-modal-header'} />
                    <div className={'absolute left-2 top-2 cursor-pointer p-1'} onClick={onClose}>
                        <IoIosClose size={20} />
                    </div>
                </div>
                <div className='px-4 py-7'>
                    <Text tid={'stacking-support-hint'} />
                </div>

            </div>
        </div>
    )
}

export default StackingSupportModal
